import * as Yup from 'yup'

import { getActivePlacementsInitialValues } from '../../../placements/helpers'

import {
  LANGUAGES,
  MIN_SPEND_TARGET_DAILY,
  MIN_SPEND_TARGET_LIFETIME,
  NAME,
  PLACEMENT_POSITIONS,
  ROAS_AVERAGE_FLOOR,
  SPEND_CAP_DAILY,
  SPEND_CAP_LIFETIME,
  TARGET_COST_CAP
} from '../../../../Multiplatform/LineItemForms/fields'
import { initialGeolocationsValues } from '../../../../ReusableFormFields/GeolocationsFields/fields'

import { OPTION_CUSTOM } from '../../../../../constants/forms'
import {
  AD_RECALL_LIFT,
  AUTOMATIC,
  CONVERSIONS,
  COST_CAP,
  MANUAL,
  MINIMUM_ROAS,
  OUTCOME_SALES
} from '../../../../../constants/campaigns'

import { geolocationsValidation, regionsValidation } from '../../../../../features/validations/gelolocations'
import { languagesCreateValidation } from '../../../../../features/validations/languages'
import nameValidation from '../../../../../features/validations/name'
import { FACEBOOK_PLATFORM } from '../../../../../constants/selectLists/platformList'
import { startTimeInitialValues, startTimeValidation } from '../../../../ReusableFormFields/StartTimeFields/fields'
import { stopTimeInitialValues, stopTimeValidation } from '../../../../ReusableFormFields/StopTimeFields/fields'
import {
  customAudiencesInitialValues,
  customAudiencesValidation
} from '../../../../ReusableFormFields/Audiences/AudiencesFields/fields'
import { getPromotedObjectInitialValues } from '../../../../../constants/selectLists/customEventTypes/fields'
import { interestsInitialValues, interestsValidation } from '../../../../ReusableFormFields/InterestsFields/fields'
import { GENDER_OPTION, GENDER_OPTION_ALL } from '../../../../ReusableFormFields/GenderFields/fields'
import {
  FREQUENCY_DAYS,
  FREQUENCY_IMPRESSIONS,
  FREQUENCY_OPTION,
  FREQUENCY_OPTION_DEFAULT
} from '../../../../ReusableFormFields/FrequencyFields/fields'
import { AGE_MAX, AGE_MIN } from '../../../fields'
import { BUDGET_DAILY, BUDGET_LIFETIME, BUDGET_OPTION } from '../../../../Multiplatform/fields'
// import { scheduleValidation } from '../../../../features/validations/schedule'

// import { scheduleInitialValues } from '../../../../features/components/FormFields/ScheduleFields/fields'

// routes
export const ROUTES_OPTION = 'routes_option'
export const AUTOMATIC_ROUTE = 'automatic_route'
export const MANUAL_ROUTE = 'manual_route'

// RECOMMENDED SETUP
export const RECOMMENDED_SETUP_OPTION = 'recommended_setup_option'
export const RECOMMENDED_SETUP_OPTION_AUTOMATIC = 'recommended_setup_option_automatic'
export const RECOMMENDED_SETUP_OPTION_MANUAL = 'recommended_setup_option_manual'

// FLAGS
export const IS_SPEND_LIFETIME = 'is_spend_lifetime'

// START TIME
export const START_OPTION = 'start_option'
export const START_OPTION_NOW = 'start_option_now'

// STOP TIME
export const STOP_OPTION = 'stop_option'
export const STOP_OPTION_ONE_WEEK = 'stop_option_one_week'
export const STOP_OPTION_ONE_MONTH = 'stop_option_one_month'
export const STOP_OPTION_INDEFINITELY = 'stop_option_indefinitely'

// SPEND
export const SPEND_OPTION = 'spend_option'
export const SPEND_OPTION_AUTOMATIC = 'spend_option_automatic'

// AGE
export const AGE_OPTION = 'age_option'
export const ANYONE_OVER_18 = 'anyone_over_18'
export const MILLENNIALS = 'millennials'
export const GEN_Z = 'gen_z'

// LANGUAGES
export const LANGUAGES_OPTION = 'languages_option'
export const SELECT_LANGUAGES = 'select_languages'

// OPTIMIZATION TYPE
export const OPTIMIZATION_TYPE = 'optimization_type'

// BIDDING TYPE
export const BIDDING_TYPE = 'bidding_type'

// TARGET COST CAP
export const OBJECTIVE = 'objective'

// ENGAGEMENT_TYPE
export const ENGAGEMENT_TYPE = 'engagement_type'
export const POST_ENGAGEMENT = 'post_engagement'
export const THRUPLAY = 'thruplay'
export const TWO_SECOND_CONTINUOUS_VIDEO_VIEWS = 'two_second_continuous_video_views'

// DESTINATION_TYPE
export const DESTINATION_TYPE = 'destination_type'
export const ON_POST = 'on_post'
export const ON_VIDEO = 'on_video'
export const ON_PAGE = 'on_page'
export const WEBSITE = 'website'

// STATUS
export const STATUS = 'status'

// task names for recommended step
export const FIRST_TASK = 'task1'
export const SECOND_TASK = 'task2'
export const THIRD_TASK = 'task3'
export const FOURTH_TASK = 'task4'
export const FIFTH_TASK = 'task5'

export const getInitialValues = ({ isLineItemsEmpty, firstLineItemObjective, campaignObjective }) => {
  const initialActivePlacementsValues = getActivePlacementsInitialValues(campaignObjective)

  return {
    // RECOMMENDED SETUP
    [RECOMMENDED_SETUP_OPTION]: RECOMMENDED_SETUP_OPTION_AUTOMATIC,

    // NAME
    [NAME]: '',

    // if campaign line items are not empty, preselect type of the first line item
    [ENGAGEMENT_TYPE]: isLineItemsEmpty ? POST_ENGAGEMENT : firstLineItemObjective,

    // ad set start time
    ...startTimeInitialValues,
    // ad set stop time
    ...stopTimeInitialValues,

    // SCHEDULE
    // ...scheduleInitialValues,

    // BUDGET
    [BUDGET_OPTION]: BUDGET_LIFETIME,
    [BUDGET_LIFETIME]: '',
    [BUDGET_DAILY]: '',

    // SPEND
    [SPEND_OPTION]: SPEND_OPTION_AUTOMATIC,
    [MIN_SPEND_TARGET_LIFETIME]: '',
    [SPEND_CAP_LIFETIME]: '',
    [MIN_SPEND_TARGET_DAILY]: '',
    [SPEND_CAP_DAILY]: '',

    // GEOLOCATIONS
    ...initialGeolocationsValues,

    // GENDER
    [GENDER_OPTION]: GENDER_OPTION_ALL,

    // AGE
    [AGE_OPTION]: ANYONE_OVER_18,
    [AGE_MIN]: 18,
    [AGE_MAX]: 65,

    // INTERESTS
    ...interestsInitialValues,

    // LANGUAGES
    [LANGUAGES_OPTION]: SELECT_LANGUAGES,
    [LANGUAGES]: [
      {
        label: 'English (All)',
        value: 1001
      }
    ],

    // FREQUENCY
    [FREQUENCY_OPTION]: FREQUENCY_OPTION_DEFAULT,
    [FREQUENCY_IMPRESSIONS]: '2',
    [FREQUENCY_DAYS]: '7',

    // OPTIMIZATION TYPE
    [OPTIMIZATION_TYPE]: AD_RECALL_LIFT,

    // AUDIENCES
    ...customAudiencesInitialValues,

    [BIDDING_TYPE]: COST_CAP,

    // TARGET COST CAP
    [TARGET_COST_CAP]: '',
    [ROAS_AVERAGE_FLOOR]: '',
    [OBJECTIVE]: '',

    // PROMOTED OBJECT
    ...getPromotedObjectInitialValues(campaignObjective),

    // placement
    [PLACEMENT_POSITIONS]: initialActivePlacementsValues,

    // STATUS
    [STATUS]: 'paused'
  }
}

export const validationSchema = (includeValuesInRequest, campaignObjective, campaignBiddingType, isAutomaticRoute) => {
  // BUDGET
  const includeBudget = includeValuesInRequest[BUDGET_OPTION]

  // SPEND
  const includeSpend = includeValuesInRequest[SPEND_OPTION]
  const isSpendLifetime = includeValuesInRequest[IS_SPEND_LIFETIME]

  return Yup.object({
    ...(!isAutomaticRoute && nameValidation),

    // ad set start time
    ...startTimeValidation(FACEBOOK_PLATFORM),
    // as set stop time
    ...stopTimeValidation,

    ...(!isAutomaticRoute && {
      // ...scheduleValidation,

      // BUDGET
      ...(includeBudget && {
        [BUDGET_LIFETIME]: Yup.string().when(BUDGET_OPTION, {
          is: BUDGET_LIFETIME,
          then: () => Yup.string().required('This field can not be empty')
        })
      }),
      ...(includeBudget && {
        [BUDGET_DAILY]: Yup.string().when(BUDGET_OPTION, {
          is: BUDGET_DAILY,
          then: () => Yup.string().required('This field can not be empty')
        })
      }),

      // SPEND
      ...(includeSpend &&
        isSpendLifetime && {
          [SPEND_CAP_LIFETIME]: Yup.string().when(SPEND_OPTION, {
            is: OPTION_CUSTOM,
            then: () =>
              Yup.string().test(SPEND_CAP_LIFETIME, 'Please enter at least one option', (value, { parent }) => {
                // check that at least one group value is entered
                return !!value || !!parent[MIN_SPEND_TARGET_LIFETIME]
              })
          })
        }),
      ...(includeSpend &&
        !isSpendLifetime && {
          [SPEND_CAP_DAILY]: Yup.string().when(SPEND_OPTION, {
            is: OPTION_CUSTOM,
            then: () =>
              Yup.string().test(SPEND_CAP_DAILY, 'Please enter at least one option', (value, { parent }) => {
                // check that at least one group value is entered
                return !!value || !!parent[MIN_SPEND_TARGET_DAILY]
              })
          })
        })
    }),

    // GEOLOCATIONS
    ...geolocationsValidation,
    ...regionsValidation,

    // INTERESTS
    ...interestsValidation,

    // LANGUAGES
    ...languagesCreateValidation,

    ...(!isAutomaticRoute && {
      // FREQUENCY
      [FREQUENCY_IMPRESSIONS]: Yup.number().when(FREQUENCY_OPTION, {
        is: OPTION_CUSTOM,
        then: () =>
          Yup.number()
            .min(1, 'Value must be between 1 and 90')
            .max(90, 'Value must be between 1 and 90')
            .required('This field can not be empty')
      }),
      [FREQUENCY_DAYS]: Yup.number().when(FREQUENCY_OPTION, {
        is: OPTION_CUSTOM,
        then: () =>
          Yup.number()
            .min(1, 'Value must be between 1 and 90')
            .max(90, 'Value must be between 1 and 90')
            .required('This field can not be empty')
      }),

      // AUDIENCES
      ...customAudiencesValidation
    }),

    // TARGET COST CAP
    ...((campaignBiddingType === MANUAL || campaignBiddingType === COST_CAP) && {
      [TARGET_COST_CAP]: Yup.string().required('This field can not be empty')
    }),
    ...(campaignBiddingType === MINIMUM_ROAS && {
      [ROAS_AVERAGE_FLOOR]: Yup.string().required('This field can not be empty')
    }),

    // validations for case with conversions campaign objective and empty bidding_type
    ...((campaignObjective === CONVERSIONS || campaignObjective === OUTCOME_SALES) &&
      !campaignBiddingType && {
        [TARGET_COST_CAP]: Yup.string().when(BIDDING_TYPE, {
          is: val => val !== AUTOMATIC && (val === COST_CAP || val === MANUAL),
          then: () => Yup.string().required('This field can not be empty')
        }),
        [ROAS_AVERAGE_FLOOR]: Yup.string().when(BIDDING_TYPE, {
          is: val => val !== AUTOMATIC && val === MINIMUM_ROAS,
          then: () => Yup.string().required('This field can not be empty')
        })
      }),

    ...(!isAutomaticRoute && {
      // PLACEMENT
      [PLACEMENT_POSITIONS]: Yup.object().test('at-least-one-selected', 'Please select at least one placement', value =>
        Object.values(value).some(item => item)
      )
    })
  })
}
